import "../../styles/Offerings/Offer.css";

const Offer = ({ offerData }) => {
  const { title, discount, year, description } = offerData;
  return (
    <div className="offer-container">
      <div className="offer-innercontainer">
        <div className="offer-title">
          {title} <span className="danger">{discount}</span> For {year}!
        </div>
        <div className="offer-desc">{description}</div>
      </div>
    </div>
  );
};

export default Offer;
